const PressMedia = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container py-5 px-lg-5">
        <div className="wow fadeInUp" data-wow-delay="0.1s">
          <p className="section-title text-secondary justify-content-center">
            The European Spirit of Youth Orchestra
          </p>
        </div>
        <div className="text-center">
          {/* <iframe
            src="https://mediagol-meride-tv.akamaized.net/proxy/iframe.php/3862/gol"
            width="630"
            height="352"
            frameborder="0"
            title="Minja e la “sua” orchestra - La videointervista di OPEN"
          >
            <p>
              Minja e la “sua” orchestra under 21: «Con la musica classica si
              può parlare anche di Europa e clima» - La videointervista - Open
            </p>
            <p>Il tuo browser non supporta il tag iframe</p>
          </iframe> */}
        </div>
      </div>
    </div>
  );
};

export default PressMedia;
